import React from 'react'
import { useRouter } from 'next/router'
import classNames from 'classnames'

import { getFullUrl, getNextLink } from '../../../utils'
import { useTranslation } from '../../../utils/providers'
import { Selectbox } from '../Form'

export default function MobileView({
  subcategories = [],
  isFullWidth = false,
}) {
  const { t, language } = useTranslation()
  const router = useRouter()

  const handleChange = (event) => {
    const target = event?.target?.value
    if (target) {
      const { isExternalLink, fullUrl } = getFullUrl(target)
      if (!isExternalLink) {
        const { internalUrl, externalUrl } = getNextLink(fullUrl, language)
        router.push(internalUrl, externalUrl)
      }
    }
  }

  const containerClasses = classNames('mb-4', {
    container: !isFullWidth,
  })

  const htmlId = 'subcategory'

  const options = [
    { label: t('SUB_CATEGORY_ALL_PRODUCTS'), value: '', disabled: true },
  ].concat(
    subcategories.map(({ catName, catLink }) => ({
      label: catName,
      value: catLink,
    }))
  )

  return (
    <form className={containerClasses}>
      <label htmlFor={htmlId} className="sr-only">
        {t('SUB_CATEGORY_LABEL')}
      </label>
      <Selectbox
        id={htmlId}
        data={{ name: 'subcategory', value: '' }}
        options={options}
        onChange={handleChange}
        materialDesign={false}
      />
    </form>
  )
}
